<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('loans')"
      :columns="columns"
      :column_search="true"
      resource_url="/loan/loan/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create_loan">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <loan-modal ref="loan_modal" @success="refresh_datatable" />
    <edit-loan-modal ref="edit_loan_modal" @success="refresh_datatable" />
    <loan-quotas-modal ref="loan_quotas_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  success_message,
  format_currency,
  format_date,
  download,
} from "@/utils";
import LoanModal from "./loan_modal/Index.vue";
import EditLoanModal from "./edit_loan_modal/Index.vue";
import LoanQuotasModal from "./loan_quotas_modal/Index.vue";
import moment from "moment";

export default {
  name: "LoanDataTable",
  components: { GenericTable, LoanModal, EditLoanModal, LoanQuotasModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("loan number"),
          searchable: true,
          data: (row) => {
            return `<div class="title is-6">${row.loan_number}</div>
            <div class="subtitle is-6 mb-0">${row.loan_type?.name || ""}</div>
            <div class="subtitle is-7">${format_date(row.create_date)}</div>`;
          },
        },
        {
          title: v.$t("customer"),
          searchable: true,
          data: (row) => {
            return `<div class="title is-6">${
              row.customer
                ? row.customer.first_name + " " + row.customer.last_name
                : ""
            }</div>`;
          },
        },
        {
          title: v.$t("amount"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">${format_currency(row.amount)}</div>
            <div class="subtitle is-7">${row.interest_rate}% - ${
              row.quotas
            } ${v.$t("quotas")}</div>`;
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            let statusClass = "";
            switch (row.status) {
              case "active":
                statusClass = "is-success";
                break;
              case "paid":
                statusClass = "is-info";
                break;
              case "defaulted":
                statusClass = "is-danger";
                break;
              case "restructured":
                statusClass = "is-warning";
                break;
              default:
                statusClass = "is-dark";
            }
            return `<span class="tag ${statusClass}">${v.$t(
              row.status
            )}</span>`;
          },
        },
        {
          title: v.$t("outstanding balance"),
          searchable: false,
          data: (row) => {
            return format_currency(row.outstanding_balance);
          },
        },
        {
          title: v.$t("actions"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("edit"),
              //   icon: "fa fa-edit",
              //   icon_class: "is-small",
              //   click: function (e) {
              //     v.edit_loan(row.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("quotas"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  v.loan_quotas(row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("pdf"),
                icon: "fa fa-file-pdf-o",
                icon_class: "is-small has-text-danger",
                click: function (e) {
                  v.generate_pdf(row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = row.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure delete loan"),
                    v,
                    () => {
                      del("/loan/loan", { uuid: uuid })
                        .then(() => {
                          v.refresh_datatable();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create_loan() {
      this.$refs.loan_modal.show_modal();
    },
    edit_loan(uuid) {
      this.$refs.edit_loan_modal.show_modal(uuid);
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
    loan_quotas(uuid) {
      this.$refs.loan_quotas_modal.show_modal(uuid);
    },
    generate_pdf(uuid) {
      let v = this;
      v.$root.loader(true);
      download(
        `/loan/loan/pdf?uuid=${uuid}`,
        `Préstamo ${uuid} ${moment().format("YYYYMMDDHHmmss")}.pdf`
      )
        .then(() => {
          success_message(v.$t("download complete"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
